var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { TransactionTypes, } from "@/shared/domain/entities/wallet-transaction";
import { Pagination } from "@/shared/presentation/components/pagination";
import { BalanceContext } from "@/shared/presentation/context-api/providers/balance";
import { TransactionsContext } from "@/shared/presentation/context-api/providers/transaction";
import { convertCentsToUnit } from "@/shared/utils";
import { Calendar, ExclamationTriangle, Repeat, Wallet, } from "@reverb-ui/icons-react";
import { Box, Button, Center, Flex, Heading, HStack, IconButton, Select, Spinner, Table, Tbody, Td, Text, Th, Thead, Tr, useDisclosure, } from "@reverb-ui/react";
import { differenceInDays, format, subHours } from "date-fns";
import React, { useContext, useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { ClientWalletContext } from "../context-api/providers/client-wallet";
import { ModalRefundPurchase } from "./modal-refund-purchase";
import { ModalSelectWallet } from "./modal-select-wallet";
var canShowChargebackButton = function (transaction) {
    var passed10DaysAfterPurchase = differenceInDays(new Date(), new Date(transaction.createdAt)) >= 10;
    var isExpired = new Date() >= new Date(transaction.expiresAt);
    return (transaction.type.code === TransactionTypes.ADD &&
        !passed10DaysAfterPurchase &&
        !isExpired &&
        !transaction.chargedback);
};
export var ClientWalletContainer = function (_a) {
    var hideBalance = _a.hideBalance, embedded = _a.embedded, enableRefund = _a.enableRefund;
    var _b = useContext(TransactionsContext), transactions = _b.transactions, metadata = _b.metadata, loadTransactions = _b.loadTransactions, loading = _b.loading;
    var _c = useContext(ClientWalletContext), clientWallets = _c.clientWallets, clientWallet = _c.clientWallet, setSelectedClientWallet = _c.setSelectedClientWallet;
    var t = useTranslation().t;
    var filterAddedTransaction = function (transactions) {
        return transactions.filter(function (transaction) { return transaction.type.code === TransactionTypes.ADD; });
    };
    var filterRemoveTransaction = function (transactions) {
        return transactions.filter(function (transaction) { return transaction.type.code === TransactionTypes.REMOVE; });
    };
    var filterAllTransaction = function (transactions) {
        return transactions;
    };
    var _d = useState({
        filter: TransactionTypes.ALL,
        handler: filterAllTransaction,
    }), transactionFilter = _d[0], setTransactionFilter = _d[1];
    var walletOptions = useMemo(function () {
        if (!clientWallets)
            return [];
        return clientWallets.map(function (clientWallet) {
            return { value: clientWallet === null || clientWallet === void 0 ? void 0 : clientWallet.walletUuid, label: clientWallet === null || clientWallet === void 0 ? void 0 : clientWallet.name };
        });
    }, [clientWallets]);
    var selectedWalletClient = useMemo(function () { return ({ value: clientWallet === null || clientWallet === void 0 ? void 0 : clientWallet.walletUuid, label: clientWallet === null || clientWallet === void 0 ? void 0 : clientWallet.name }); }, [clientWallet]);
    var getFilterButtonProps = function (filter) {
        return {
            colorScheme: transactionFilter.filter === filter && "blue",
            bg: transactionFilter.filter === filter && "blue.500",
            borderColor: transactionFilter.filter === filter ? "blue.500" : "gray.200",
            variant: transactionFilter.filter === filter ? "solid" : "outline",
            color: transactionFilter.filter === filter ? "white" : "gray.800",
            _focus: { outline: "none" },
        };
    };
    var _e = useState(), selectedTransaction = _e[0], setSelectedTransaction = _e[1];
    var _f = useDisclosure(), isOpen = _f.isOpen, onClose = _f.onClose, onOpen = _f.onOpen;
    var _g = useDisclosure(), isOpenSelectWallet = _g.isOpen, onCloseSelectWallet = _g.onClose, onOpenSelectWallet = _g.onOpen;
    useEffect(function () {
        if (clientWallets.length > 1) {
            onOpenSelectWallet();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [clientWallets]);
    var refundTransaction = function (transaction) {
        setSelectedTransaction(transaction);
        onOpen();
    };
    return (React.createElement(BalanceContext.Consumer, null, function (_a) {
        var balance = _a.balance, expiringCredits = _a.expiringCredits;
        return (React.createElement(Box, { pb: 8, px: !!embedded ? 0 : 12 },
            !embedded && (React.createElement(Heading, { mb: "8", fontSize: "2xl" }, t("wallet.wallet"))),
            React.createElement(Flex, { flexWrap: "wrap", flexDirection: !!embedded ? "column" : "row" },
                !hideBalance && (React.createElement(Box, { minW: "215px", maxW: "380px" },
                    walletOptions.length > 1 && (React.createElement(Box, { bg: "white", boxShadow: "md", mb: "5", borderRadius: "8", p: "6" },
                        React.createElement(Text, { color: "gray.800", mb: "2", align: "left", fontSize: "md" }, t("wallet.selected-wallet")),
                        React.createElement(Select, { isFullWidth: true, options: walletOptions, value: selectedWalletClient, onChange: function (selected) {
                                var newClientWallet = clientWallets.find(function (cw) { return (cw === null || cw === void 0 ? void 0 : cw.walletUuid) === selected.value; });
                                setSelectedClientWallet(newClientWallet);
                            } }))),
                    React.createElement(Box, { bg: "white", boxShadow: "md", borderRadius: "8", p: "6" },
                        React.createElement(Center, { w: "100%", flexDir: "column" },
                            React.createElement(Flex, { fontWeight: "bold", alignItems: "center" },
                                React.createElement(Wallet, { color: "blue.500" }),
                                React.createElement(Text, { fontSize: "md", px: "1" }, "RC"),
                                React.createElement(Text, { fontSize: "3xl" }, convertCentsToUnit(balance) || 0)),
                            React.createElement(Text, { color: "gray.500", fontSize: "xs" }, t("wallet.rock-content-credits")))),
                    React.createElement(Flex, { py: "5", alignItems: "center", minW: "615px" }, expiringCredits.length > 0 && (React.createElement(React.Fragment, null,
                        React.createElement(Text, { textTransform: "uppercase", color: "gray.500", fontSize: "xs", fontWeight: "medium", pr: "1" }, t("wallet.credits-about-to-expire")),
                        React.createElement(ExclamationTriangle, { color: "gray.400", size: "sm" })))),
                    expiringCredits.map(function (credit, index) { return (React.createElement(Flex, { key: index, px: "6", py: "3", bg: "white", borderRadius: "8", mb: "4", boxShadow: "md", alignItems: "center", justifyContent: "space-between" },
                        React.createElement(Flex, { alignItems: "center" },
                            React.createElement(Calendar, { color: "gray.400" }),
                            React.createElement(Center, { flexDir: "column", px: "3" },
                                React.createElement(Text, { fontSize: "xs", fontWeight: "medium", textTransform: "uppercase", color: "gray.400" }, format(new Date(credit.expiresAt), "MMM")),
                                React.createElement(Text, { color: "gray.700", fontWeight: "bold" }, new Date(credit.expiresAt).getDay()))),
                        React.createElement(Flex, null,
                            React.createElement(Center, { color: "red.500", fontWeight: "bold", pr: "2" },
                                React.createElement(Text, { pr: "1", fontSize: "sm" }, "RC"),
                                React.createElement(Text, { fontSize: "xl" }, convertCentsToUnit(credit.amountToExpire)))))); }))),
                React.createElement(Box, { flex: "1", ml: "5", minW: "615px" },
                    React.createElement(Box, { bg: "white", boxShadow: "md", borderRadius: "8", pb: "6" },
                        React.createElement(HStack, { justifyContent: "space-between", p: 6, pb: 3 },
                            React.createElement(Box, null,
                                React.createElement(Text, { fontSize: "xl", color: "black", fontWeight: "semibold" }, t("wallet.transaction-statements")),
                                React.createElement(Text, { color: "gray.500" }, t("wallet.all-transactions-carried"))),
                            React.createElement(HStack, { gridGap: "2" },
                                React.createElement(Button, __assign({ onClick: function () {
                                        setTransactionFilter({
                                            filter: TransactionTypes.ADD,
                                            handler: filterAddedTransaction,
                                        });
                                    } }, getFilterButtonProps(TransactionTypes.ADD)),
                                    React.createElement(Text, { fontSize: "sm", fontWeight: "semibold" }, t("wallet.edded"))),
                                React.createElement(Button, __assign({ onClick: function () {
                                        setTransactionFilter({
                                            filter: TransactionTypes.REMOVE,
                                            handler: filterRemoveTransaction,
                                        });
                                    } }, getFilterButtonProps(TransactionTypes.REMOVE)),
                                    React.createElement(Text, { fontSize: "sm", fontWeight: "semibold" }, t("wallet.spent"))),
                                React.createElement(Button, __assign({ onClick: function () {
                                        setTransactionFilter({
                                            filter: TransactionTypes.ALL,
                                            handler: filterAllTransaction,
                                        });
                                    } }, getFilterButtonProps(TransactionTypes.ALL)),
                                    React.createElement(Text, { fontSize: "sm", fontWeight: "semibold" }, t("wallet.all-transactions"))))),
                        React.createElement(Table, { variant: "simple" },
                            React.createElement(Thead, { bg: "gray.50" },
                                React.createElement(Tr, null,
                                    React.createElement(Th, null, "Id"),
                                    React.createElement(Th, null, t("wallet.date")),
                                    React.createElement(Th, null, t("wallet.credits")),
                                    React.createElement(Th, null, t("wallet.description")),
                                    React.createElement(Th, { isNumeric: true }))),
                            !loading && (React.createElement(Tbody, null, transactionFilter
                                .handler(transactions)
                                .map(function (transaction, index) { return (React.createElement(Tr, { key: index },
                                React.createElement(Td, null,
                                    "#",
                                    transaction.id),
                                React.createElement(Td, { color: "gray.700", fontSize: "sm" }, format(subHours(new Date(transaction.createdAt), 3), "dd/MM/yyyy HH:mm")),
                                React.createElement(Td, { fontSize: "sm", color: transaction.type.code === TransactionTypes.ADD
                                        ? "green.500"
                                        : "red.500" },
                                    transaction.type.code ===
                                        TransactionTypes.REMOVE && "-",
                                    convertCentsToUnit(transaction.value)),
                                React.createElement(Td, null, transaction.description),
                                React.createElement(Td, { isNumeric: true }, enableRefund &&
                                    canShowChargebackButton(transaction) && (React.createElement(IconButton, { title: "Refund", "aria-label": "Refund", variant: "outline", onClick: function () {
                                        return refundTransaction(transaction);
                                    }, icon: React.createElement(Repeat, null) }))))); })))),
                        loading && (React.createElement(Center, { p: "50", width: "100%" },
                            React.createElement(Spinner, { color: "blue.500" }))),
                        transactions.length === 0 && !loading && (React.createElement(Center, { mt: "5" },
                            React.createElement(Text, { color: "grey", textAlign: "center" }, t("wallet.no-transactions")))),
                        React.createElement(Pagination, { count: metadata === null || metadata === void 0 ? void 0 : metadata.count, page: (metadata === null || metadata === void 0 ? void 0 : metadata.page) || 1, onChange: function (page) { return loadTransactions(page); }, perPage: (metadata === null || metadata === void 0 ? void 0 : metadata.limit) || 10 })))),
            isOpen && (React.createElement(ModalRefundPurchase, { isOpen: isOpen, transaction: selectedTransaction, onClose: onClose })),
            isOpenSelectWallet && (React.createElement(ModalSelectWallet, { isOpen: isOpenSelectWallet, onClose: onCloseSelectWallet }))));
    }));
};
